

export const caseList: any[] = [
  {
    name: "可道",
    title: "小冰AI数字人微课解决方案入选中山市 “人工智能 +” 创新清单",
    date: "2025/7/12",
    link: "https://mp.weixin.qq.com/s/3DpjSBnzyv_yB-LzAAJg7g",
  },
  {
    name: "可道",
    title: "中山CIO大会重磅看点！小冰AI一体机惊艳亮相，3天上线超给力",
    date: "2025/4/18",
    link: "https://mp.weixin.qq.com/s/JAIJ-Ry6O_EOw9Lj2lLjCg",
  },
  {
    name: "可道",
    title: "中山市首创！用AI为老人编织一张 “有温度的服务网”",
    date: "2025/7/17",
    link: "https://mp.weixin.qq.com/s/N5zqsOr2wPTMA82V5veuXA",
  },
  {
    name: "可道",
    title: "小冰AI智能体赋能政务——西区街道 “企业专属AI管家” 树立服务新标杆",
    date: "2025/6/23",
    link: "https://mp.weixin.qq.com/s/NOyykqk0ki9z7aFnFBp5oQ",
  },
  {
    name: "爱冰",
    title: "AI数字人赋能企业案例-盈科律师事务所",
    date: "2024/10/18",
    link: "https://mp.weixin.qq.com/s/o7MIg0LXRG4xm0R4QxKXfg",
  },
  {
    name: "爱冰",
    title: "AI数字人赋能企业案例-博达物流",
    date: "2024/10/18",
    link: "https://mp.weixin.qq.com/s/voXCDG38RZaYkvfKFO0RVw",
  },
  {
    name: "爱冰",
    title: "AI数字人赋能企业案例-云南精细财务",
    date: "2024/10/18",
    link: "https://mp.weixin.qq.com/s/NUqS2E-WNjp2bwGYIlcdCw",
  },
  {
    name: "爱冰",
    title: "AI数字人赋能企业案例-北京君都昆明律所",
    date: "2024/10/18",
    link: "https://mp.weixin.qq.com/s/ZbFux-9MMV9vr2G_I0pJQA",
  },
  {
    name: "爱冰",
    title: "AI数字人赋能企业案例-芭纳曼形象美学",
    date: "2024/10/18",
    link: "https://mp.weixin.qq.com/s/izSwuwBgBfUV2Ro3nMtZRA",
  },
  {
    name: "爱冰",
    title: "AI数字人赋能企业案例-艾珂美学家居",
    date: "2024/10/18",
    link: "https://mp.weixin.qq.com/s/G00i4dw6327Ukau-zN2uTw",
  },
  {
    name: "重庆爱冰",
    title:
      "独家专访：【段记西服】创始人——段远红：拥抱AI时代，百年匠心如何借力数字人破局？​",
    date: "2025/6/18",
    link: "https://mp.weixin.qq.com/s/DWyKddcLtL77RSnzxxmBig",
  },
  {
    name: "可道",
    title: "福州市妇联小冰AI数字人",
    date: "2024/12/24",
    link: "https://mp.weixin.qq.com/s/fQE4VICnbUGmFr9GxeTkGw",
  },
  {
    name: "可道",
    title: "小冰AI数字人入驻中山移动5G数智体验馆，开启科技互动新纪元",
    date: "2024/12/6",
    link: "https://mp.weixin.qq.com/s/W51y-YmjncgL0sgHVQuhKg",
  },
  {
    name: "可道",
    title: "德和衡、德衡律师事务所首批AI数字律师亮相，打造数字化品牌矩阵",
    date: "2024/12/6",
    link: "https://mp.weixin.qq.com/s/FarfnS-GhHXcEewocWTn2g",
  },
  {
    name: "视界联动",
    title: "抢跑数智时代 | 茶情报&小冰数字人，启动茶行业内容营销新纪元",
    date: "2023/5/29",
    link: "https://mp.weixin.qq.com/s/NEL23pIjz-FqALDYkwyMtQ",
  },
  {
    name: "光启数字",
    title: "AI营销员24小时在线自动获客，闭眼躺着流量涌入私域！",
    date: "2025/7/16",
    link: " https://mp.weixin.qq.com/s/2ikcf5tZ1_FgjjFdx6CMrA",
  },
  {
    name: "光启数字",
    title: "美美的公安AI主播上线啦",
    date: "2025/5/17",
    link: "https://www.douyin.com/video/7505232522016492852",
  },
  {
    name: "陕西裕盛和",
    title: "小冰AI数字人：科技赋能教育，开启智能教学“分身”新纪元",
    date: "2025/6/30",
    link: "  https://mp.weixin.qq.com/s/ByoZBPDEhhRLerGGj4XPBg",
  },
  {
    name: "芯火种",
    title: "株洲奇迹集团董事长杨建辉：AI数字人应用于零售业",
    date: "2024/11/29",
    link: "https://mp.weixin.qq.com/s/E1VejXZMweecAJM2jFcHnA",
  },
  {
    name: "芯火种",
    title: "有车科技CEO徐晨华：可持续建设品牌领导数字人资产",
    date: "2024/11/14",
    link: "https://mp.weixin.qq.com/s/OqzpW00xVWm9ANrrKs01ww",
  },
];
caseList.forEach((item, index) => {
  const img = new URL(`./covers/${index + 1}.png`, import.meta.url).href;
  item.img = img;
});
export const mainCaseList = [
  caseList[0],
  caseList[1],
  caseList.filter((item) => item.name === "爱冰")[0]!,
  caseList.filter((item) => item.name === "爱冰")[1]!,
  caseList.filter((item) => item.name === "视界联动")[0]!,
  caseList.filter((item) => item.name === "光启数字")[0]!,
  caseList.filter((item) => item.name === "光启数字")[1]!,
  caseList.filter((item) => item.name === "陕西裕盛和")[0]!,
  caseList.filter((item) => item.name === "芯火种")[0]!,
];
const data = {
    caseList,
    mainCaseList,
}
export default data;